<mat-toolbar class="main-header">
  <!-- <button class="sidebar-toggle-btn" (click)="toggleSidebar()" aria-label="Toggle sidebar">
    <mat-icon style="color: #fff;">arrow_back_ios</mat-icon>
  </button> -->
  <!-- Logo and App Name -->
  <div class="logo-section">
    <!-- <div class="">
      <mat-icon style="color: #000; align-items: center; display: flex;cursor: pointer; "
        routerLink="/templates">arrow_back</mat-icon>

    </div> -->
    <div class="logo-icon">
      <mat-icon (click)="toggleSidebar()" style="cursor: pointer;">menu</mat-icon>
    </div>
    <span class="app-name">Otter AI</span>


    <!-- Interview Code -->
    <div class="interview-code desktop-only">
      <span>Interview Code:</span>
      <span class="code">{{templateId}}</span>
      <mat-icon class="mat-icon-copy" [class.animate-copied]="templateId" (click)="copyCode()"
        matTooltip="{{ copied ? 'Copied!' : 'Copy link' }}">
        {{ copied ? 'check_circle' : 'content_copy' }}
      </mat-icon>
    </div>
  </div>
  <!-- Spacer -->
  <span class="spacer"></span>

  <!-- Action Buttons (Desktop and Large Screen) -->
  <div class="action-buttons">
    <!-- Coding mode: answers in this conversation become exact before/after code changes -->
    <button *ngIf="codingModeAvailable" type="button" class="coding-mode-toggle" role="switch"
      [class.on]="codingMode" [attr.aria-checked]="codingMode" (click)="codingModeToggle.emit()"
      [title]="codingMode ? 'Coding mode is on: answers show exact code changes. Click to turn off.' : 'Turn on coding mode: answers show exact code changes'">
      <span class="coding-mode-icon" aria-hidden="true">&lt;/&gt;</span>
      <span class="coding-mode-label">Coding mode</span>
      <span class="coding-mode-switch" aria-hidden="true"><span class="coding-mode-knob"></span></span>
    </button>
    <!-- header.component.html -->
    <div class="zoom-controls">
      <button class="zoom-btn" (click)="onZoomIn()">+</button>
      <button class="zoom-btn" (click)="onZoomOut()">−</button>
    </div>

      <button *ngIf="templateId" type="button" class="icon-btn" (click)="onRefresh()" aria-label="Refresh chat" title="Refresh chat">
      <mat-icon>refresh</mat-icon>
    </button> 

    <button *ngIf="shouldShowBackButton()" type="button" class="back-btn" (click)="onBack()" aria-label="Back" title="Back">
      <mat-icon>arrow_back</mat-icon>
      <span>Back</span>
    </button>

  

    <button class="purple" (click)="newInterview()">
      <mat-icon>group_outline</mat-icon>
      New Interview
    </button>
    <button class="warn" (click)="signOut()">
      <mat-icon>logout</mat-icon>
      Logout
    </button>
  </div>

  <!-- Mobile Menu Toggle (Hamburger) -->

  <mat-icon class="mobile-menu-toggle" style="color: #000;" (click)="toggleMenu()">more_vert

  </mat-icon>


  <!-- Mobile Dropdown Menu -->
  <div *ngIf="menuOpen" class="mobile-menu">
    <button *ngIf="codingModeAvailable" type="button" class="coding-mode-toggle mobile" role="switch"
      [class.on]="codingMode" [attr.aria-checked]="codingMode" (click)="codingModeToggle.emit()">
      <span class="coding-mode-icon" aria-hidden="true">&lt;/&gt;</span>
      <span class="coding-mode-label">Coding mode</span>
      <span class="coding-mode-switch" aria-hidden="true"><span class="coding-mode-knob"></span></span>
    </button>
    <div class="zoom-controls">
      <button class="zoom-btn" (click)="onZoomIn()">+</button>
      <button class="zoom-btn" (click)="onZoomOut()">−</button>
    </div>
    <div class="interview-code">
      <span>Code:</span>
      <span class="code">{{templateId}}</span>
      <mat-icon class="mat-icon-copy" [class.animate-copied]="templateId" (click)="copyCode()"
        matTooltip="{{ copied ? 'Copied!' : 'Copy link' }}">
        {{ copied ? 'check_circle' : 'content_copy' }}
      </mat-icon>
    </div>
    <button *ngIf="templateId" (click)="onRefresh()"><mat-icon>refresh</mat-icon> Refresh Chat</button>
    <button (click)="newInterview()">New Interview</button>
    <button (click)="signOut()">Logout</button>
    <button *ngIf="shouldShowBackButton()" type="button" class="back-btn" (click)="onBack()" aria-label="Back" title="Back">
      <mat-icon>arrow_back</mat-icon>
      <span>Back</span>
    </button>
  </div>
</mat-toolbar>
